import { render, staticRenderFns } from "./B2cOffsetHistoricModal.vue?vue&type=template&id=375fd9e3&lang=pug"
import script from "./B2cOffsetHistoricModal.vue?vue&type=script&lang=js"
export * from "./B2cOffsetHistoricModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports